import type { DayCloseLabels } from "./types";

export const trDayCloseLabels: DayCloseLabels = {
  page: {
    title: "Gün Sonu Kapanışı",
    subtitle: "Kasa sayımı, uzlaştırma ve Z raporu",
    breadcrumb: "Kasa / Gün Sonu",
    backToCashier: "Kasaya Dön",
    branchLabel: "Şube",
    dateLabel: "İş günü",
    openedByLabel: "Açan",
    openedAtLabel: "Açılış",
  },
  cta: {
    start: "Başlat",
    openWizard: "Sihirbazı Aç",
    continueDraft: "Taslağa Devam Et",
    viewZReport: "Z Raporunu Gör",
    reopen: "Yeniden Aç",
    back: "← Geri",
    next: "İleri →",
    confirm: "Onayla",
    cancel: "Vazgeç",
    retry: "Tekrar Dene",
  },
  steps: {
    prerequisites: {
      key: "Ön Kontroller",
      title: "Ön Kontroller",
      description: "Açık siparişler, park edilmiş işlemler ve personel durumu kontrol edilmeli.",
      empty: "Tüm kontroller tamam.",
      blocked: "Devam edebilmek için engelleyen sorunları çözün.",
      action: "Düzelt",
      items: {
        parked_orders: "Park edilmiş siparişler",
        open_orders: "Açık siparişler",
        pending_card_capture: "Bekleyen kart yakalamaları",
        clocked_in_staff: "Mesaide kalan personel",
        unadjusted_tips: "Düzeltilmemiş bahşişler",
      },
    },
    cash: {
      key: "Nakit Sayımı",
      title: "Nakit Sayımı",
      description: "Çekmecedeki tüm banknot ve madeni paraları sayın.",
      expected: "Beklenen",
      counted: "Sayılan",
      openingFloat: "Açılış kasası",
      denomination: "Birim",
      count: "Adet",
      subtotal: "Tutar",
      tip: "Klavyeyi açmak için adet alanına dokunun.",
    },
    non_cash: {
      key: "Diğer Tahsilatlar",
      title: "Kart, Hediye Çeki ve Havale",
      description: "POS dökümlerinden ve banka panelinden tutarları doğrulayın.",
      method: "Yöntem",
      expected: "Beklenen",
      counted: "Sayılan",
      reference: "Slip / Referans",
      referencePlaceholder: "Slip no veya batch ID",
      txCount: "İşlem",
      methods: {
        card: "Kart (POS)",
        gift_card: "Hediye Çeki",
        transfer: "Banka Havalesi",
        on_account: "Cari Hesap",
        loyalty_points: "Sadakat Puanı",
      },
    },
    review: {
      key: "Uzlaştırma",
      title: "Fark İncelemesi",
      description: "Tüm tahsilatların beklenen ve sayılan tutarlarını gözden geçirin.",
      variance: "Fark",
      total: "Toplam |Fark|",
      withinTolerance: "Tolerans dahilinde",
      outOfTolerance: "Tolerans dışı",
      requiresManagerOverride: "Yönetici onayı gerekli",
      requiresOwnerOverride: "Sahip onayı gerekli (sert blok)",
      depositLabel: "Bankaya Yatırılacak",
      closingFloatLabel: "Kapanış Kasa Bakiyesi",
      depositHelp: "Kapanış kasası + Bankaya yatırılacak = Sayılan nakit",
    },
    submit: {
      key: "Onay & Z Raporu",
      title: "Günü Kapat",
      description: "Onayladığınızda Z raporu üretilecek ve gün geriye alınamaz.",
      submitCta: "Günü Kapat",
      submitting: "Kapatılıyor…",
      successTitle: "Gün Kapandı",
      successDescription: "Z raporu hazır, e-Fatura akışı tetiklendi.",
      zReport: "Z Raporu",
      download: "PDF İndir",
      print: "Yazdır",
    },
  },
  summary: {
    expected: "Beklenen",
    counted: "Sayılan",
    variance: "Fark",
    status: "Durum",
  },
  denominations: {
    TRY_200: "₺200", TRY_100: "₺100", TRY_50: "₺50", TRY_20: "₺20",
    TRY_10: "₺10", TRY_5: "₺5", TRY_1: "₺1",
    TRY_050: "50 kr", TRY_025: "25 kr", TRY_010: "10 kr", TRY_005: "5 kr", TRY_001: "1 kr",
  },
  variance: {
    over: "Fazla",
    short: "Eksik",
    match: "Eşit",
    rowDetail: "Detay",
  },
  override: {
    title: "Yönetici Onayı Gerekli",
    description: "Tolerans dışı fark için yönetici PIN'i ve sebep gerekli.",
    managerPin: "Yönetici PIN",
    managerPinPlaceholder: "4 haneli PIN",
    reasonCode: "Sebep",
    reasonCodes: {
      counting_error: "Sayım hatası",
      register_drop: "Kasadan transfer",
      customer_dispute: "Müşteri itirazı",
      damaged_note: "Yıpranmış banknot",
      other_explained: "Diğer (açıklama)",
    },
    explanation: "Açıklama",
    explanationPlaceholder: "En az 10 karakter…",
    submit: "Onayla ve Kapat",
    errorInvalidPin: "Geçersiz PIN",
    errorExplanation: "Lütfen en az 10 karakterlik açıklama girin",
  },
  reopen: {
    title: "Günü Yeniden Aç",
    description: "Yalnızca işletme sahibi yeniden açabilir. İşlem denetim kaydına yazılır.",
    reasonLabel: "Sebep",
    reasonPlaceholder: "Yeniden açma gerekçesi…",
    submit: "Yeniden Aç",
    success: "Gün yeniden açıldı",
  },
  errors: {
    sessionNotFound: "Oturum bulunamadı",
    networkOffline: "Çevrimdışısınız. Bağlantı geri gelene kadar ilerleyemezsiniz.",
    managerOverrideRequired: "Yönetici onayı gerekli",
    ownerOverrideRequired: "Sert blok — sahip onayı gerekli",
    submitFailed: "Kapanış başarısız oldu. Lütfen tekrar deneyin.",
    mobileBlocked: "Gün sonu kapanışı tablet veya masaüstünden yapılmalıdır.",
  },
  toast: {
    draftSaved: "Taslak kaydedildi",
    cashPatched: "Nakit sayımı güncellendi",
    nonCashPatched: "Tahsilat güncellendi",
    depositPatched: "Yatırım tutarı kaydedildi",
    submitted: "Gün başarıyla kapatıldı",
    reopened: "Gün yeniden açıldı",
  },
  zReportLabels: {
    branch: "Şube",
    date: "Tarih",
    closedBy: "Kapatan",
    closedAt: "Kapanış",
    gross: "Brüt",
    discount: "İndirim",
    tax: "KDV",
    net: "Net",
    refund: "İade",
    voided: "İptal",
    tenders: "Tahsilat Dökümü",
    categories: "Kategori Dökümü",
    denominations: "Çekmece Sayımı",
    override: "Yönetici Onayı",
  },
  currencyPrefix: "₺",
};

export const enDayCloseLabels: DayCloseLabels = {
  page: {
    title: "Day Close",
    subtitle: "Cash count, reconciliation and Z-report",
    breadcrumb: "Cashier / Day Close",
    backToCashier: "Back to Cashier",
    branchLabel: "Branch",
    dateLabel: "Business date",
    openedByLabel: "Opened by",
    openedAtLabel: "Opened at",
  },
  cta: {
    start: "Start",
    openWizard: "Open Wizard",
    continueDraft: "Continue Draft",
    viewZReport: "View Z-Report",
    reopen: "Reopen",
    back: "← Back",
    next: "Next →",
    confirm: "Confirm",
    cancel: "Cancel",
    retry: "Retry",
  },
  steps: {
    prerequisites: {
      key: "Prerequisites",
      title: "Prerequisites",
      description: "Open orders, parked items and clocked-in staff must be resolved.",
      empty: "All checks passed.",
      blocked: "Resolve blockers to continue.",
      action: "Fix",
      items: {
        parked_orders: "Parked orders",
        open_orders: "Open orders",
        pending_card_capture: "Pending card captures",
        clocked_in_staff: "Clocked-in staff",
        unadjusted_tips: "Unadjusted tips",
      },
    },
    cash: {
      key: "Cash Count",
      title: "Cash Count",
      description: "Count every note and coin in the drawer.",
      expected: "Expected",
      counted: "Counted",
      openingFloat: "Opening float",
      denomination: "Denomination",
      count: "Qty",
      subtotal: "Subtotal",
      tip: "Tap a count input to open the keypad.",
    },
    non_cash: {
      key: "Other Tenders",
      title: "Card, Gift Card & Transfer",
      description: "Verify totals against POS slips and bank panel.",
      method: "Method",
      expected: "Expected",
      counted: "Counted",
      reference: "Slip / Reference",
      referencePlaceholder: "Slip no or batch ID",
      txCount: "Tx",
      methods: {
        card: "Card (POS)",
        gift_card: "Gift Card",
        transfer: "Bank Transfer",
        on_account: "On Account",
        loyalty_points: "Loyalty Points",
      },
    },
    review: {
      key: "Review",
      title: "Variance Review",
      description: "Review expected vs counted across every tender.",
      variance: "Variance",
      total: "Total |Variance|",
      withinTolerance: "Within tolerance",
      outOfTolerance: "Out of tolerance",
      requiresManagerOverride: "Manager override required",
      requiresOwnerOverride: "Owner override required (hard block)",
      depositLabel: "Bank Deposit",
      closingFloatLabel: "Closing Float",
      depositHelp: "Closing float + Bank deposit = Counted cash",
    },
    submit: {
      key: "Confirm & Z-Report",
      title: "Close Day",
      description: "Once confirmed, the Z-report will be generated and the day cannot be reopened.",
      submitCta: "Close Day",
      submitting: "Closing…",
      successTitle: "Day Closed",
      successDescription: "Z-report ready, e-invoice flow triggered.",
      zReport: "Z-Report",
      download: "Download PDF",
      print: "Print",
    },
  },
  summary: {
    expected: "Expected",
    counted: "Counted",
    variance: "Variance",
    status: "Status",
  },
  denominations: {
    TRY_200: "₺200", TRY_100: "₺100", TRY_50: "₺50", TRY_20: "₺20",
    TRY_10: "₺10", TRY_5: "₺5", TRY_1: "₺1",
    TRY_050: "50 kr", TRY_025: "25 kr", TRY_010: "10 kr", TRY_005: "5 kr", TRY_001: "1 kr",
  },
  variance: {
    over: "Over",
    short: "Short",
    match: "Match",
    rowDetail: "Detail",
  },
  override: {
    title: "Manager Override Required",
    description: "An out-of-tolerance variance requires a manager PIN and reason.",
    managerPin: "Manager PIN",
    managerPinPlaceholder: "4-digit PIN",
    reasonCode: "Reason",
    reasonCodes: {
      counting_error: "Counting error",
      register_drop: "Register drop",
      customer_dispute: "Customer dispute",
      damaged_note: "Damaged note",
      other_explained: "Other (explain)",
    },
    explanation: "Explanation",
    explanationPlaceholder: "At least 10 characters…",
    submit: "Approve & Close",
    errorInvalidPin: "Invalid PIN",
    errorExplanation: "Please enter at least 10 characters",
  },
  reopen: {
    title: "Reopen Day",
    description: "Only owners can reopen. The action is recorded in the audit log.",
    reasonLabel: "Reason",
    reasonPlaceholder: "Reason for reopening…",
    submit: "Reopen",
    success: "Day reopened",
  },
  errors: {
    sessionNotFound: "Session not found",
    networkOffline: "You are offline. You cannot proceed until the connection returns.",
    managerOverrideRequired: "Manager override required",
    ownerOverrideRequired: "Hard block — owner override required",
    submitFailed: "Close failed. Please retry.",
    mobileBlocked: "Day close must be performed on a tablet or desktop.",
  },
  toast: {
    draftSaved: "Draft saved",
    cashPatched: "Cash count updated",
    nonCashPatched: "Tender updated",
    depositPatched: "Deposit amount saved",
    submitted: "Day closed successfully",
    reopened: "Day reopened",
  },
  zReportLabels: {
    branch: "Branch",
    date: "Date",
    closedBy: "Closed by",
    closedAt: "Closed at",
    gross: "Gross",
    discount: "Discount",
    tax: "Tax",
    net: "Net",
    refund: "Refund",
    voided: "Voided",
    tenders: "Tender Breakdown",
    categories: "Category Breakdown",
    denominations: "Drawer Count",
    override: "Manager Override",
  },
  currencyPrefix: "₺",
};
